import ReportingDashboard from './Dashboard';
import Reporting from './Reporting';
import Reports from './Reports';

export default Reporting;
export { ReportingDashboard, Reports };
